/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const e=(e,c)=>o=>c(e(o)),c=(...c)=>c.reduce(e);export{c as pipe};
//# sourceMappingURL=pipe.js.map
